import { useFormSelector } from '../../../redux/formStoreHooks'
import { exportMemberAge } from '@fusion-advantage/formlib'
import L1ErrorBlock from '../l1/L1ErrorBlock'
import { selectExport } from '../../../redux/selectForm'

enum DefinedError {
	PatientAgeUnknown = 'patientAgeUnknown'
}

interface L4DefinedErrorCheckBlockProps {
	definedError: DefinedError
}

const L4DefinedErrorCheckBlock = ({definedError}: L4DefinedErrorCheckBlockProps) => {
	const exp = useFormSelector(selectExport)
	let errors = []
	switch(definedError) {
		case DefinedError.PatientAgeUnknown:
			if(!exp || !exportMemberAge(exp)) {
				errors.push('Patient age is not known')
			}
			break
		default:
			errors.push(`check ${definedError} not defined`)
	}
	if(errors.length < 1) {
		return null
	} 
	return <L1ErrorBlock bullets={errors} />
}

export default L4DefinedErrorCheckBlock
